<template>
  <div class="login-bottom">
    <div class="login-logo">
      <a href="./login">
        <img src="../assets/images/logo02.png" alt="">
      </a>
    </div>
    <div>
      <small>{{copyright}}</small>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils.js'

export default {
  name: 'LoginFooter',
  data () {
    return {
      copyright: ''
    }
  },
  methods: {
    getDomainConfig () {
      let domainConfig = utils.getDomainConfig()
      this.copyright = domainConfig.copyright
    }
  },
  mounted () {
    this.getDomainConfig()
  }
}
</script>



// WEBPACK FOOTER //
// LoginFooter.vue?80046ae6